import { render } from "./AppMovilNew.vue?vue&type=template&id=3f073650&scoped=true"
import script from "./AppMovilNew.vue?vue&type=script&lang=js"
export * from "./AppMovilNew.vue?vue&type=script&lang=js"

import "./AppMovilNew.vue?vue&type=style&index=0&id=3f073650&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f073650"]])

export default __exports__